import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { Button, DialogRoot, DialogTrigger, type TreeData } from '@gitbook/spine-react';

import { AddLinkDialog } from './LinkDialog';

type TitledItem = { title: string };

export function AddSubLinkButton<T extends TreeData<TitledItem>>(props: {
    treeRef: React.MutableRefObject<T>;
    item: T['items'][number];
    maxSubLinks: number;
    siteSpaceIds: string[];
}) {
    const { treeRef, item, maxSubLinks, siteSpaceIds } = props;

    if (item.parentKey) {
        return <div className="size-6" />;
    }

    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    iconOnly
                    kind="blank"
                    size="small"
                    leadingIcon={Icon.Plus}
                    label="Add sublink"
                    disabled={Boolean(item.children && item.children.length >= maxSubLinks)}
                    tooltip={
                        item.children && item.children.length >= maxSubLinks
                            ? {
                                  label: `You can't add more than ${maxSubLinks} sublinks.`,
                              }
                            : undefined
                    }
                />
            </DialogTrigger>
            <AddLinkDialog
                title={`Add sublink to ${item.value.title}`}
                onAdd={(newItem) => {
                    const tree = treeRef.current;
                    // Append the new item to the parent item.
                    tree.append(item.key, newItem);

                    // Expand the parent item.
                    const expandedKeys = new Set(tree.expandedKeys);
                    expandedKeys.add(item.key);
                    tree.setExpandedKeys(expandedKeys);
                }}
                itemType="link"
                siteSpaceIds={siteSpaceIds}
            />
        </DialogRoot>
    );
}
